import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "919836692288";
const DEFAULT_MESSAGE = "Hello Dr. Chandrani Jha, I'd like to enquire about an appointment.";

export default function WhatsAppFab() {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;
  return (
    <a
      data-testid="whatsapp-fab"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group inline-flex items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-5 h-14 shadow-[0_12px_32px_-12px_rgba(37,211,102,0.7)] hover:bg-[#1ebe5d] hover:-translate-y-0.5 transition-all duration-300"
    >
      <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
        <span className="absolute inset-0 rounded-full bg-white/25 animate-ping" />
        <MessageCircle className="w-5 h-5 relative" strokeWidth={1.75} />
      </span>
      <span className="hidden sm:block font-medium tracking-tight">WhatsApp</span>
    </a>
  );
}
